// @flow
import * as React from "react";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Accordion from "@material-ui/core/Accordion";
import { SuspenseWithPerf } from "reactfire";
import Box from "@material-ui/core/Box";

type Props = {
  id: string,
  title: string,
  form: React.Node,
  icon: React.Node,
};
function AdminEntry({ id, title, form, icon }: Props) {
  return (
    <Accordion TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
      >
        <Box mr={1}>{icon}</Box>
        <Typography> {title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <SuspenseWithPerf fallback="Lädt" traceId="AdminEntry">
          {form}
        </SuspenseWithPerf>
      </AccordionDetails>
    </Accordion>
  );
}

export default AdminEntry;
